import { ProfileApi } from './ProfileApi'
import { Profile, RundotGameAPI } from '../rundot-game-api/types'

/**
 * Playground profile API.
 *
 * In playground mode (browser + real backend), profile identity must match the backend's
 * notion of profileId (which is effectively the Firebase Auth UID in this codebase).
 *
 * This implementation reads from `rundotGameApi._profileData`, which is populated by
 * PlaygroundHost when Firebase auth state changes.
 *
 * NOTE: `ProfileApi` is synchronous, so we return a placeholder profile until the
 * user signs in and `_profileData` is available.
 */
export class PlaygroundProfileApi implements ProfileApi {
  private readonly rundotGameApi: RundotGameAPI

  constructor(rundotGameApi: RundotGameAPI) {
    this.rundotGameApi = rundotGameApi
  }

  getCurrentProfile(): Profile {
    const profile = this.rundotGameApi._profileData
    if (profile?.id && profile?.username) {
      return {
        id: profile.id,
        username: profile.username,
        name: profile.name,
        avatarUrl: profile.avatarUrl,
        isAnonymous: profile.isAnonymous,
      }
    }

    // Placeholder until sign-in + backend profile fetch completes
    return {
      id: 'unknown-user',
      username: 'unknown-user',
      isAnonymous: true,
    }
  }
}


